import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BarComponent } from './bar.component';

@Component({
  selector: 'oc-container',
  standalone: true,
  imports: [CommonModule, RouterModule, BarComponent],
  providers: [],
  template: `
    <div class="oc-container">
      <oc-bar></oc-bar>
      <div class="oc-main">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: `
    .oc-container {
      min-height: 100vh;
      display: flex;
      flex-direction: column;
    }

    .oc-main {
      flex: 1;
      padding-top: 60px;
    }
  `,
})
export class ContainerComponent {}
